{
  "schemaVersion": 1,
  "approved": true,
  "mood": "energized",
  "posts": [
    {
      "id": "feeling-energized-01",
      "title": "Give a good idea a first step",
      "text": "Choose one small thing you could start today. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "pantry-cooking", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-001-lemon-white-beans.webp",
      "alt": "Creamy white beans and blistered cherry tomatoes with basil, lemon zest and toasted bread in an ivory bowl.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "circle",
        "prompt": "Choose one small thing you could start today."
      },
      "visualMetadata": {
        "tags": ["energized", "pantry-cooking", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-02",
      "title": "Look for the crisp edge",
      "text": "Find a contrast that makes the scene feel lively. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "roasted-cabbage", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-002-tahini-cabbage.webp",
      "alt": "Roasted cabbage wedges on tahini sauce with golden chickpeas and parsley.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "arcs",
        "prompt": "Find a contrast that makes the scene feel lively."
      },
      "visualMetadata": {
        "tags": ["energized", "roasted-cabbage", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-03",
      "title": "A little momentum in the bowl",
      "text": "Trace one curve, then choose your next practical step. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "noodles", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-003-mushroom-miso-udon.webp",
      "alt": "Thick udon noodles with golden mushrooms, spring onion and sesame in a dark bowl.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "orbit",
        "prompt": "Trace one curve, then choose your next practical step."
      },
      "visualMetadata": {
        "tags": ["energized", "noodles", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-04",
      "title": "Colour with a purpose",
      "text": "Pick a bright ingredient you would like to cook. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "lentils", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-004-carrot-lentil-salad.webp",
      "alt": "Roasted carrots, green lentils, orange pieces and dill on a terracotta platter.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "circle",
        "prompt": "Pick a bright ingredient you would like to cook."
      },
      "visualMetadata": {
        "tags": ["energized", "lentils", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-05",
      "title": "Green light for a small beginning",
      "text": "Name a task you can begin without finishing it now. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "pesto", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-005-broccoli-pesto-pasta.webp",
      "alt": "Rigatoni coated in green broccoli pesto with walnuts, lemon zest and cheese shavings.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "arcs",
        "prompt": "Name a task you can begin without finishing it now."
      },
      "visualMetadata": {
        "tags": ["energized", "pesto", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-06",
      "title": "Make room for a fresh combination",
      "text": "Think of two familiar ingredients to try together. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "cauliflower", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-006-golden-cauliflower.webp",
      "alt": "Golden cauliflower florets over green herb yogurt with toasted almonds and pomegranate.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "orbit",
        "prompt": "Think of two familiar ingredients to try together."
      },
      "visualMetadata": {
        "tags": ["energized", "cauliflower", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-07",
      "title": "An afternoon worth making",
      "text": "Choose a simple project you would enjoy starting. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "baking", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-007-rosemary-pear-galette.webp",
      "alt": "Rustic pear galette with thin pear slices, flaky folded pastry and a few rosemary needles.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "circle",
        "prompt": "Choose a simple project you would enjoy starting."
      },
      "visualMetadata": {
        "tags": ["energized", "baking", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-08",
      "title": "Let colour start the conversation",
      "text": "Find two colours that bring each other to life. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "citrus-cake", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-008-citrus-semolina-cake.webp",
      "alt": "Golden orange semolina cake topped with pistachios and orange slices, with a cut wedge showing the crumb.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "arcs",
        "prompt": "Find two colours that bring each other to life."
      },
      "visualMetadata": {
        "tags": ["energized", "citrus-cake", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-09",
      "title": "A clean, bright next move",
      "text": "Choose one thing to prepare before your next meal. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "fennel", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-009-fennel-orange-salad.webp",
      "alt": "Shaved fennel, orange segments, dark olive halves and fennel fronds in a white bowl.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "orbit",
        "prompt": "Choose one thing to prepare before your next meal."
      },
      "visualMetadata": {
        "tags": ["energized", "fennel", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    },
    {
      "id": "feeling-energized-10",
      "title": "Build something in small layers",
      "text": "Imagine one manageable step, then a second. Look for a detail that catches your attention, then decide whether it suggests anything you want to try. Keep the picture still or play the slow visual cue. This is an invitation, with no countdown or task to finish.",
      "tone": "energized",
      "hashtags": ["energized", "visual-moment", "tostadas", "slow-looking"],
      "reviewedAt": "2026-10-08",
      "image": "/assets/lifestyle-food-010-sweet-potato-tostadas.webp",
      "alt": "Crisp corn tostadas layered with black beans, roasted sweet potato, red cabbage, avocado and coriander.",
      "imageAspectRatio": 0.6666666666666666,
      "imageCredit": "myAudience · AI-generated food illustration",
      "imageLicense": "Original generated illustration; interpreted scene, not a documentary photograph.",
      "imageChanges": "Original portrait illustration, responsive WebP. Optional animation is applied separately by the app.",
      "sourceURL": null,
      "sourceTitle": "myAudience · Original visual activity",
      "feelingItem": {
        "version": "feeling-items-0.1.0",
        "mood": "energized",
        "shape": "circle",
        "prompt": "Imagine one manageable step, then a second."
      },
      "visualMetadata": {
        "tags": ["energized", "tostadas", "visual-moment"],
        "themes": ["visual-moments"],
        "colors": [],
        "contentTone": "energized"
      }
    }
  ]
}
